import React from 'react';
import type { DNSZone } from '../../../types/dns';

interface ZoneFeaturesProps {
  zone: DNSZone;
}

// Placeholder components for DNSSEC and Email Routing
// These are simplified versions - full implementations would be more complex

export const DNSSECCard: React.FC<ZoneFeaturesProps> = ({ zone }) => {
  return (
    <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-4 mb-6">
      <h3 className="text-heading-2 text-slate-900 dark:text-white mb-2">DNSSEC</h3>
      <p className="text-body-small text-slate-600 dark:text-slate-400">
        DNS Security Extensions status for {zone.name}
      </p>
      <div className="mt-3">
        <span className="status status-warning">Not Configured</span>
      </div>
    </div>
  );
};

export const EmailRoutingCard: React.FC<ZoneFeaturesProps> = ({ zone }) => {
  return (
    <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl p-4 mb-6">
      <h3 className="text-heading-2 text-slate-900 dark:text-white mb-2">Email Routing</h3>
      <p className="text-body-small text-slate-600 dark:text-slate-400">
        Email routing configuration for {zone.name}
      </p>
      <div className="mt-3">
        <span className="status status-warning">Disabled</span>
      </div>
    </div>
  );
};